export default {
	termsAndConditions: {
		lastUpdate: 'Τελευταία ενημέρωση: 10 Ιουνίου 2024',
		content: `
		<p>Οι Όροι που θα βρείτε παρακάτω είναι σημαντικοί γιατί:</p>
		<ul>
			<li>Θεωρούν τα νόμιμα δικαιώματά τους στο {siteName}.</li>
			<li>Εξηγήστε τα δικαιώματα που μας εκχωρείτε όταν χρησιμοποιείτε το {siteName}.</li>
			<li>
				Περιγράφουν τους κανόνες που πρέπει να σέβονται όλοι όταν χρησιμοποιούν το {siteName}.
			</li>
		</ul>
		<p>
			Διαβάστε προσεκτικά αυτούς τους Όρους, καθώς και το {privacyPolicyLink} και οποιονδήποτε άλλο
			έγγραφα που αναφέρονται στους παρόντες Όρους.
		</p>
		<p>Ας ξεκινήσουμε...</p>
		<h3>1. ΕΙΣΑΓΩΓΗ ΚΑΙ ΔΕΔΟΜΕΝΑ ΤΟΥ {siteNameUpper}.</h3>
		<p>
			Ο ιστότοπος {websiteLink} (εφεξής ο "Ιστότοπος") ανήκει στην εταιρεία
			{siteName} S.L (εφεξής η "{siteName}"), Μια εταιρεία
			έχει ενσωματωθεί σύμφωνα με την ισπανική νομοθεσία με διεύθυνση Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Βαρκελώνη), κάτοχος του αριθμού CIF
			B-56.768.260 και καταχωρήθηκε στο Εμπορικό Μητρώο της Βαρκελώνης στον τόμο
			49065, Folio 0033, Φύλλο Β-606324, 1η Εγγραφή.
		</p>
		<p>
			Το {siteName} θέτει τον Ιστότοπο στη διάθεσή σας για να μπορείτε να μεταβείτε
			Γνωρίστε μας καλύτερα, γνωρίστε τις υπηρεσίες που παρέχουμε και αν θέλετε, μπορείτε να επικοινωνήσετε
			και, όπου ενδείκνυται, συμβόλαιο μαζί μας.
		</p>
		<h3>2. ΣΚΟΠΟΣ ΚΑΙ ΠΕΔΙΟ ΕΦΑΡΜΟΓΗΣ ΤΩΝ ΟΡΩΝ ΧΡΗΣΗΣ</h3>
		<p>
			Αυτοί οι όροι χρήσης αποτελούν, μαζί με το {privacyPolicyLink} και το
			{cookiesPolicyLink}, το νομικό πλαίσιο που ρυθμίζει τη χρήση του ιστότοπου
			{Σύνδεσμος ιστοσελίδας}. Αυτοί οι όροι χρήσης θα είναι διαθέσιμοι σε εσάς στον ιστότοπο
			στα αγγλικά ώστε να μπορείτε να τα συμβουλευτείτε, να τα αρχειοθετήσετε ή να τα εκτυπώσετε ανά πάσα στιγμή και
			όποτε θέλεις.
		</p>
		<p>
			Για να γνωρίζετε οποιαδήποτε ερώτηση σχετικά με τη θεραπεία που πραγματοποιείται από το {siteName}.
			σχετικά με τα προσωπικά σας δεδομένα, επισκεφτείτε το {privacyPolicyLink} και το {cookiesPolicyLink}.
			Και οι δύο πολιτικές θα είναι επίσης διαθέσιμες σε εσάς στα αγγλικά, ώστε να μπορείτε
			συμβουλευτείτε, αρχειοθετήστε ή εκτυπώστε τα ανά πάσα στιγμή.<br />
			Το {siteName} χρησιμοποιεί cookies τρίτων στον Ιστότοπο. Για να μάθετε περισσότερα
			σχετικά με τον τύπο των cookie που χρησιμοποιούνται στον ιστό {websiteLink}, τον σκοπό τους και τον τρόπο
			για να διαμορφώσετε το πρόγραμμα περιήγησής σας σε περίπτωση που δεν θέλετε να χρησιμοποιήσουμε αυτά τα cookies,
			επισκεφτείτε το {cookiesPolicyLink} μας.
		</p>
		<p>
			Και οι δύο αυτοί όροι χρήσης, καθώς και το {privacyPolicyLink} και το 
			Οι {cookiesPolicyLink} έχουν προετοιμαστεί σύμφωνα με τις διατάξεις της τρέχουσας
			ισχύουσες ρυθμίσεις, μεταξύ άλλων, ο Νόμος 34/2002, για τις Υπηρεσίες της
			Κοινωνία της Πληροφορίας και Ηλεκτρονικό Εμπόριο και Κανονισμός (ΕΕ) 2016/679 του
			του Ευρωπαϊκού Κοινοβουλίου και του Συμβουλίου, της 27ης Απριλίου 2016, σχετικά με την
			προστασία των φυσικών προσώπων σε σχέση με την επεξεργασία προσωπικών
			δεδομένων και την ελεύθερη κυκλοφορία των δεδομένων αυτών και με την οποία η Οδηγία 95/46 / ΕΚ
			καταργείται.
		</p>
		<h3>3. ΠΡΟΣΒΑΣΗ ΣΤΗΝ ΙΣΤΟΣΕΛΙΔΑ ΚΑΙ ΑΠΟΔΟΧΗ</h3>
		<p>
			Η πρόσβαση στην Ιστοσελίδα είναι δωρεάν εκτός από το μέρος που σχετίζεται με το κόστος της
			σύνδεση μέσω του τηλεπικοινωνιακού δικτύου που παρέχεται από το Διαδίκτυο
			πάροχο πρόσβασης που έχετε συνάψει. Μπορείτε να περιηγηθείτε ελεύθερα στον Ιστότοπο
			και αποκτήστε πρόσβαση όσες φορές θέλετε. Για πρόσβαση και πλοήγηση στον Ιστότοπο,
			δεν χρειάζεται να εγγραφείτε, εκτός εάν θέλετε να προσλάβετε μια υπηρεσία.
		</p>
		<p>
			Η χρήση του ιστότοπου σας δίνει την προϋπόθεση του χρήστη του ιστότοπου
			(εφεξής «Χρήστης») και συνεπάγεται την πλήρη και ανεπιφύλακτη αποδοχή του
			αυτούς τους όρους χρήσης, καθώς και το {privacyPolicyLink} και το {cookiesPolicyLink}
			της Ιστοσελίδας. Επιπλέον, συμφωνείτε να μην χρησιμοποιείτε την Υπηρεσία για παράνομη χρήση
			σκοποί.
		</p>
		<p>
			Με την πρόσβαση στον Ιστότοπο και την περιήγησή του, δηλώνετε κάτω από σας
			ευθύνη ότι είστε νόμιμος και ότι έχετε τα απαραίτητα νομικά
			δυνατότητα πρόσβασης στον Ιστότοπο και χρήσης του, δηλώνοντας επίσης πλήρως ότι έχετε
			κατανοούν και αποδέχονται αυτούς τους όρους χρήσης χωρίς επιφύλαξη.
		</p>
		<p>
			Από την άλλη, σας ενημερώνουμε ότι για νομικούς λόγους αρχειοθετούμε το
			ηλεκτρονικά έγγραφα στα οποία επισημοποιούνται οι αγορές. Μπορείτε να έχετε πρόσβαση
			αυτά τα έγγραφα ανά πάσα στιγμή ζητώντας τα στη διεύθυνση: {supportLink}.
		</p>
		<h3>4. ΟΡΟΙ ΧΡΗΣΗΣ ΤΟΥ ΙΣΤΟΤΟΠΟΥ</h3>
		<p>
			Ο Χρήστης συμφωνεί να χρησιμοποιεί την Ιστοσελίδα σύμφωνα με αυτούς τους όρους χρήσης,
			ισχύουσα νομοθεσία και καλή πίστη. Έτσι, ο Χρήστης θα απαντήσει στο {siteName}.
			 και ενώπιον οποιουδήποτε τρίτου για τις ζημίες και τις ζημίες που προκύπτουν από
			η χρήση αντίθετη με αυτούς τους όρους, τη νομοθεσία και την καλή πίστη που έγινε
			από τον Χρήστη της Ιστοσελίδας.
		</p>
		<h3>5. ΠΕΡΙΓΡΑΦΗ ΤΗΣ ΥΠΗΡΕΣΙΑΣ</h3>
		<p>
			Μέσω της Υπηρεσίας, το {siteName} επιτρέπει τη συνδρομή στην υπηρεσία
			πραγματοποιήστε επεξεργασία εικόνας.
		</p>
		<p>
			Η γλώσσα στην οποία η σύμβαση μεταξύ του {siteName} και του αγοραστή
			θα συνάπτεται θα είναι αυτή της χώρας προέλευσης.<br />
			Η διαδικασία αγοράς στην ηλεκτρονική υπηρεσία θα είναι η εξής:
		</p>
		<ol>
			<li>Πρέπει να εγγραφείτε στον ιστότοπο με όνομα χρήστη και κωδικό πρόσβασης.</li>
			<li>
				Κατά την εγγραφή, ο χρήστης πρέπει να επιλέξει ένα από τα προγράμματα πληρωμής
				βρίσκονται στην ενότητα Τιμές και θα χορηγούνται πιστώσεις ανάλογα με την
				επιλεγμένο σχέδιο. Κάθε πίστωση θα σας επιτρέπει να επεξεργαστείτε μία εικόνα.
			</li>
			<li>
				Μετά την αγορά της υπηρεσίας, ο χρήστης θα έχει διαχείριση
				πίνακα όπου θα βρουν:
				<ul>
					<li>
						Μια ενότητα με μια λίστα με όλες τις εικόνες που έχουν υποστεί επεξεργασία, που
						μπορείτε να το επεξεργαστείτε όσες φορές θέλετε και να το κατεβάσετε στο δικό σας
						συσκευή.
					</li>
					<li>
						Ένα τμήμα σχεδίων και πληρωμών για να συμβουλευτείτε τα τιμολόγια και να ακυρώσετε τα
						συνδρομή.
					</li>
					<li>Μια ενότητα του Λογαριασμού μου για να μπορείτε να αλλάξετε τις προτιμήσεις λογαριασμού.</li>
				</ul>
			</li>
		</ol>
		<p>
			Μόλις γίνει η αγορά της υπηρεσίας, θα επιβεβαιωθεί από
			στέλνοντας ένα email, εντός 24 ωρών το πολύ, στη διεύθυνση που έχετε
			υποδεικνύεται. Θα υποδεικνύει την υπηρεσία, τον τρόπο ακύρωσης της συνδρομής, της
			το ποσό, τους ισχύοντες φόρους, τον τρόπο πληρωμής και τους ισχύοντες όρους και
			συνθήκες.
		</p>
		<h4>5.1 Συνδρομή</h4>
		<p>
			Η συνδρομή υπηρεσίας ποικίλλει ανάλογα με το επιλεγμένο πρόγραμμα και θα είναι
			ανανεώνεται αυτόματα για το ίδιο χρονικό διάστημα μέχρι τη λήξη του.
			Εάν δεν ακυρώσετε τη συνδρομή σας, μας εξουσιοδοτείτε να φορτώσουμε τη συνδρομή
			αντίστοιχη ετήσια συνδρομή στον τρόπο πληρωμής σας.
		</p>
		<p>
			Μπορείτε να ακυρώσετε τη συνδρομή σας στην Υπηρεσία ανά πάσα στιγμή και θα το κάνετε
			συνεχίστε να έχετε πρόσβαση σε αυτό μέχρι το τέλος της ετήσιας περιόδου χρέωσής σας. Προς την
			στο βαθμό που επιτρέπεται από το νόμο, οι πληρωμές δεν επιστρέφονται και δεν παρέχουμε
			επιστροφές χρημάτων ή πιστώσεις για μερικές περιόδους ετήσιας συνδρομής.
		</p>
		<h3>6. ΤΙΜΗ ΚΑΙ ΦΟΡΟΙ</h3>
		<p>
			Οι τιμές των προϊόντων που προσφέρονται στο {siteName} αναγράφονται σε ευρώ
			(€) ή το νόμισμα της χώρας από την οποία γίνεται η αγορά, η Αξία
			Ο προστιθέμενος φόρος (ΦΠΑ) που ισχύει κατά τη στιγμή της αγοράς επιβάλλεται στην τιμή του
			προϊόντα.
		</p>
		<p>
			Σε κάθε περίπτωση, η πράξη θα μπορούσε να απαλλάσσεται ή να μην υπόκειται σε ΦΠΑ ανάλογα με
			τη χώρα διαμονής σας ή την κατάσταση στην οποία ενεργείτε. Γι 'αυτό το λόγο,
			σε ορισμένες περιπτώσεις η τελική τιμή της παραγγελίας μπορεί να τροποποιηθεί σε σχέση με την
			εμφανίζεται ένα.<br />
			Οι αγορές που πραγματοποιούνται από υποκείμενα που απαλλάσσονται από την πληρωμή ΦΠΑ θα το δηλώνουν από
			αποστολή του αριθμού ΑΦΜ/NIF μέσω email στη διεύθυνση {supportLink}, χωρίς εγγραφή
			αγορές με τον εν λόγω φόρο.
		</p>
		<h3>7. ΤΡΟΠΟΣ ΠΛΗΡΩΜΗΣ</h3>
		<p>
			Η ηλεκτρονική πληρωμή της αγορασμένης υπηρεσίας μπορεί να γίνει με πιστωτική ή χρεωστική κάρτα.
			Υπό αυτή την έννοια, το {siteName} ενημερώνει τους κατόχους πιστωτικών και χρεωστικών καρτών ότι
			οι συναλλαγές στο ηλεκτρονικό κατάστημα πραγματοποιούνται μέσω ασφαλούς πληρωμής
			gateway, χρησιμοποιώντας τεχνολογία SSL για να εγγυηθεί την ασφάλεια της μετάδοσης δεδομένων.
		</p>
		<h3>8. ΔΙΚΑΙΩΜΑ ΑΠΟΧΩΡΗΣΗΣ ΚΑΙ ΕΠΙΣΤΡΟΦΗΣ ΧΡΗΜΑΤΩΝ</h3>
		<h4>8.1. Δικαίωμα υπαναχώρησης</h4>
		<p>
			Δεδομένου του είδους του προϊόντος που διατίθεται στην αγορά στην ηλεκτρονική μας υπηρεσία, το λογισμικό σε ψηφιακό
			μορφή QR, το δικαίωμα υπαναχώρησης δεν θα ισχύει σύμφωνα με
			άρθρο 103, στοιχείο ιγ) του Βασιλικού Νομοθετικού Διατάγματος 1/2007, της 16ης Νοεμβρίου, από
			το ότι το αναθεωρημένο κείμενο του Γενικού Νόμου για την Προάσπιση των Καταναλωτών και
			Χρήστες και άλλοι συμπληρωματικοί νόμοι εγκρίνονται.
		</p>
		<h4>8.2. Επιστροφές χρημάτων</h4>
		<p>
			Ανεξάρτητα από το πρόγραμμα που έχει επιλέξει ο χρήστης, τα ποσά που καταβάλλονται από τον χρήστη και προς
			ο βαθμός που επιτρέπεται από το νόμο δεν θα επιστρέφεται.
		</p>
		<p>
			Η συμβατική υπηρεσία δεν μπορεί να εκχωρηθεί ή να μεταβιβαστεί σε άλλους χρήστες του
			η υπηρεσία.
		</p>
		<p>
			Σε κάθε περίπτωση, ο χρήστης μπορεί να κάνει χρήση της συμβατικής υπηρεσίας μέχρι το τέλος της
			τη συμβατική περίοδο.
		</p>
		<h3>9. ΙΣΧΥΟΣ ΠΡΟΣΦΟΡΩΝ</h3>
		<p>
			Οι υπηρεσίες που προσφέρονται στην Υπηρεσία και οι τιμές τους θα είναι διαθέσιμες
			αγοράζουν ενώ βρίσκονται στον κατάλογο των υπηρεσιών που εμφανίζονται μέσω αυτού
			δικτυακός τόπος.
		</p>
		<p>
			Σε κάθε περίπτωση, το {siteName} διατηρεί το δικαίωμα να κάνει τις τροποποιήσεις του
			κρίνει σκόπιμο στην Υπηρεσία, να μπορεί να ενημερώσει προϊόντα και υπηρεσίες
			ανάλογα με την αγορά.
		</p>
		<p>
			Το {siteName} διατηρεί το δικαίωμα να αλλάξει τις τιμές χωρίς προηγούμενη ειδοποίηση. Εμείς
			σας ενημερώνουμε ότι παρά τις ενημερώσεις που γίνονται στις τιμές των
			Υπηρεσία, θα μπορούσαν να περιέχουν σφάλματα. Θα διορθώσουμε αμέσως τυχόν σφάλματα
			εμφανίζονται, αλλά δεν θα είναι δεσμευτικές για την Υπηρεσία.
		</p>
		<h3>10. ΑΣΦΑΛΕΙΑ</h3>
		<p>
			Όπως αναφέρθηκε παραπάνω, ολόκληρη η διαδικασία αγοράς, καθώς και η μετάδοση
			των προσωπικών σας δεδομένων και των συστημάτων πληρωμών σας, πραγματοποιείται σε ασφαλή σελίδα και
			με κρυπτογραφημένο τρόπο μέσω του πρωτοκόλλου SSL.
		</p>
		<p>
			Εγγυόμαστε την ασφάλεια της Υπηρεσίας σύμφωνα με την τρέχουσα
			τεχνολογικές γνώσεις. Ωστόσο, το {siteName} δεν μπορεί να εγγυηθεί πλήρως
			μελλοντική ασφάλεια της Υπηρεσίας. Σε κάθε περίπτωση, υποσχόμαστε να διορθώσουμε και
			εφαρμόσει τα κατάλληλα διορθωτικά μέτρα για τη διόρθωση μιας πιθανής ασφάλειας
			παραβίαση το συντομότερο δυνατό.
		</p>
		<p>
			Συμφωνείτε να ειδοποιήσετε το {siteName}, αμέσως και μέσω email {supportLink}
			οποιασδήποτε κατάστασης που θα μπορούσε να οδηγήσει στην πλαστοπροσωπία της ταυτότητας ενός χρήστη.
		</p>
		<h3>11. ΤΡΟΠΟΠΟΙΗΣΕΙΣ ΚΑΙ ΑΚΥΡΟΤΗΤΑ</h3>
		<p>
			Ενδέχεται να ενημερώσουμε τους όρους και τις προϋποθέσεις της Υπηρεσίας και στο μέλλον
			ως χαρακτηριστικά και λειτουργίες της ίδιας της Υπηρεσίας.
		</p>
		<p>
			Θα σας ενημερώσουμε για τις αλλαγές στους όρους και τις προϋποθέσεις δημοσιεύοντας μια ειδοποίηση
			σε περίοπτη θέση στον ιστότοπό μας ή/και μέσω email.
		</p>
		<p>
			Εάν δηλωθεί οποιαδήποτε ρήτρα που περιλαμβάνεται σε αυτούς τους όρους και προϋποθέσεις, πλήρως ή
			μερικώς, μηδενική ή αναποτελεσματική, θα επηρεάσει μόνο την εν λόγω διάταξη ή το μέρος
			από αυτό που είναι μηδενικό ή αναποτελεσματικό. Οι όροι και οι προϋποθέσεις θα ισχύουν
			οτιδήποτε άλλο, που έχει τέτοια διάταξη, ή το μέρος αυτής που επηρεάζεται, από
			δεν τοποθετείται.
		</p>
		<h3>12. ΑΠΑΙΤΗΣΕΙΣ ΚΑΙ ΕΝΕΡΓΕΙΕΣ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΤΗ ΣΥΜΒΑΣΗ</h3>
		<p>
			Στο μέτρο του δυνατού, αυτή η Υπηρεσία διέπεται από την ισπανική νομοθεσία.<br />
			Προκειμένου να απλοποιηθεί η επίλυση των αξιώσεων μέσω αστικών διαδικασιών και
			μείωση του κόστους, δεν αποκλείουμε την πιθανότητα να υποταχτούμε σε ένα
			Equity Διαιτησία του Διαιτητικού Δικαστηρίου των Εμπορικών Επιμελητηρίων και
			Βιομηχανία. Υπό αυτή την έννοια και σύμφωνα με τους ισχύοντες κανονισμούς,
			 Το {siteName} ενημερώνει για την ύπαρξη ευρωπαϊκής διαδικτυακής επίλυσης διαφορών
			πλατφόρμα που διευκολύνει την εξωδικαστική επίλυση τέτοιων διαφορών για
			συμβάσεις που συνάπτονται επίσης ηλεκτρονικά μεταξύ καταναλωτών και υπηρεσιών Διαδικτύου
			παρόχους. Η πρόσβαση σε αυτήν την πλατφόρμα είναι δυνατή μέσω της ακόλουθης ιστοσελίδας:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ</h3>
		<p>
			Η Ιστοσελίδα και το περιεχόμενό της υπόκεινται σε προστασία κατά την εφαρμογή της
			ισχύοντες εθνικοί κανονισμοί για την Πνευματική ή/και Βιομηχανική Ιδιοκτησία, όπως
			καθώς και κατ' εφαρμογή των διεθνών συμβάσεων που ισχύουν σε αυτές
			θέματα. Ο χρήστης {siteName} είναι ο κάτοχος ή έχει λάβει δεόντως άδεια για όλα τα
			Δικαιώματα πνευματικής και βιομηχανικής ιδιοκτησίας στον Ιστότοπο και στο περιεχόμενό του.
		</p>
		<p>
			Οποιαδήποτε μορφή αναπαραγωγής, διανομής, δημόσιας επικοινωνίας, μετασχηματισμού,
			διάθεση και, γενικά, οποιαδήποτε άλλη πράξη εκμετάλλευσης είτε όχι
			για εμπορικούς σκοπούς της Ιστοσελίδας ή του περιεχομένου της, χωρίς την προηγούμενη
			ρητή συγκατάθεση του {siteName}. Απαγορεύεται ρητά η διαγραφή του
			ταυτοποίηση δεδομένων του {siteName} ως κατόχου του Intellectual και
			Δικαιώματα Βιομηχανικής Ιδιοκτησίας της Ιστοσελίδας ή του περιεχομένου της.
		</p>
		<p>
			Το {siteName} διατηρεί όλα τα δικαιώματα πνευματικής και βιομηχανικής ιδιοκτησίας
			πάνω από την Ιστοσελίδα και το περιεχόμενό της, επιφυλάσσοντας και την άσκηση κάθε νομίμου
			ενέργειες που αντιστοιχούν σε αυτήν προκειμένου να παύσει, να αποτρέψει ή να διώξει οποιαδήποτε
			παράνομη χρήση της Ιστοσελίδας ή του περιεχομένου της. Σε καμία περίπτωση και με την υπ’ αριθ
			περιστάσεις κάνει πρόσβαση στον Ιστότοπο ή χρήση του από τον Χρήστη ή τρίτο
			τα μέρη συνιστούν ή συνεπάγονται εκχώρηση οποιουδήποτε είδους από το {siteName} του
			τα δικαιώματα Πνευματικής ή Βιομηχανικής Ιδιοκτησίας του Ιστότοπου ή του περιεχομένου του.
			Σε καμία περίπτωση η έλλειψη απαίτησης από το {siteName} να διακόψει τη χρήση του
			Ο ιστότοπος ή το περιεχόμενό του είναι παράνομο ή αντίθετο με αυτούς τους όρους
			κατανοητή ως σιωπηρή συναίνεση του {siteName} σε τέτοιες χρήσεις ή ως παραίτηση
			της άσκησης οποιασδήποτε δικαιοπραξίας που τυχόν αντιστοιχεί σε αυτό.
		</p>
		<h3>14. ΕΥΘΥΝΕΣ ΚΑΙ ΕΓΓΥΗΣΕΙΣ</h3>
		<p>
			Ο Χρήστης πρέπει να χρησιμοποιεί την Ιστοσελίδα και το περιεχόμενό της σύμφωνα με την
			τις διατάξεις αυτών των όρων χρήσης, την ισχύουσα νομοθεσία και την καλή πίστη. Οποιος
			χρήση του ιστότοπου ή του περιεχομένου του σε αντίθεση με αυτούς τους γενικούς όρους, το
			νόμος ή καλή πίστη απαγορεύεται ρητά, ανεξάρτητα από το αν η εν λόγω χρήση έχει
			οικονομικό σκοπό ή όχι.<br />
			Ο χρήστης θα είναι υπεύθυνος για οποιαδήποτε ζημιά ή βλάβη προκληθεί στο {siteName}
			 ή σε τρίτους που προέρχονται άμεσα ή έμμεσα από οποιαδήποτε χρήση
			ότι ο Χρήστης κάνει τον Ιστότοπο ή το περιεχόμενό του αντίθετα με αυτά
			συνθήκες, νόμος, ηθική, δημόσια τάξη ή καλή πίστη.
		</p>
		<p>
			Για να είναι προσβάσιμο στον Χρήστη ο ιστότοπος και το περιεχόμενό του, {siteName}
			 απαιτεί υπηρεσίες που παρέχονται από τρίτους. Είναι δυνατό να
			παρά τις προσπάθειες που καταβάλλονται από τον χρήστη {siteName} να διατηρήσει τον ιστότοπο διαθέσιμο
			και είναι προσβάσιμο στους χρήστες, η διαθεσιμότητά του μπορεί να ανασταλεί, να διακοπεί ή
			ακυρώθηκε για λόγους πέρα από το {siteName}. Γι' αυτό {siteName}
			δεν εγγυάται την απουσία διακοπών ή σφαλμάτων στην πρόσβαση στο
			Ιστότοπος ή τα περιεχόμενά του, ούτε ότι ενημερώνονται ή εμφανίζονται πάντα
			την τελευταία τους έκδοση. Κατά συνέπεια, το {siteName} απορρίπτει οποιαδήποτε
			ευθύνη για ζημιές που μπορεί να προκύψουν στον Χρήστη ή σε τρίτα μέρη όπως
			αποτέλεσμα της αναστολής, διακοπής, έλλειψης συνέχειας, διακοπής δικτύου
			ή αποσύνδεση της Ιστοσελίδας.
		</p>
		<p>
			Σε καμία περίπτωση και σε καμία περίπτωση δεν θα ευθύνεται ο {siteName}
			ζημιές ή απώλειες που προκλήθηκαν στον χρήστη από αιτίες που δεν μπορούν να αποδοθούν στο {siteName}
			 όπως ενδεικτικά και σε καμία περίπτωση περιοριστική φυσική
			καταστροφές, καταστάσεις ανωτέρας βίας ή εξαιρετικά επείγουσας ανάγκης, ιοί, επιβλαβείς
			εξαρτήματα, δυσλειτουργίες του προγράμματος περιήγησης, πτώση δικτύου, εισβολές υπολογιστή ή
			επιθέσεις τρίτων.
		</p>
		<h3>15. ΣΥΝΔΕΣΜΟΙ</h3>
		<p>
			Οι ιστότοποι, οι πλατφόρμες, τα φόρουμ, οι συνομιλίες, τα ιστολόγια ή τα εξωτερικά κοινωνικά δίκτυα που
			σύνδεσμος ή σύνδεσμος προς τον Ιστότοπο πρέπει να ενημερώνει ξεκάθαρα ότι δεν το έχουν
			εξουσιοδότηση ή επίβλεψη του {siteName} και του εν λόγω συνδέσμου ή
			ο σύνδεσμος δεν συνεπάγεται, υποθέτει ή υπονοεί οποιουδήποτε είδους συσχέτιση μεταξύ του {siteName}
			 και τους ιστότοπους, τις πλατφόρμες, τα φόρουμ, τις συνομιλίες, τα ιστολόγια ή εξωτερικά
			κοινωνικά δίκτυα που συνδέονται ή συνδέονται με τον Ιστότοπο.
		</p>
		<p>
			Σε κάθε περίπτωση, οποιοσδήποτε σύνδεσμος προορίζεται για την Ιστοσελίδα πρέπει να κατευθύνεται
			απευθείας στην αρχική σελίδα ή στην αρχική σελίδα του ιστότοπου κάνοντας κλικ στη διεύθυνση URL
			του ιστότοπου που καλύπτει ολόκληρη την οθόνη της αρχικής σελίδας ή της σελίδας έναρξης του
			τον Ιστότοπο, ώστε ο σύνδεσμος να είναι απόλυτος και πλήρης χωρίς τη χρήση του
			πλαίσια, πλαίσια ή υπερσυνδέσμους. Το {siteName} δεν ανταποκρίνεται σε καμία περίπτωση
			και υπό οποιεσδήποτε συνθήκες στο περιεχόμενο, τις πληροφορίες ή τα δεδομένα που σχετίζονται με το
			τον ιστότοπο, το περιεχόμενό του ή οποιοδήποτε άλλο θέμα που περιέχεται στους ιστότοπους, τις πλατφόρμες,
			φόρουμ, συνομιλίες, ιστολόγια ή κοινωνικά δίκτυα τρίτων που συνδέονται ή συνδέονται με το
			Δικτυακός τόπος.
		</p>
		<p>
			Απαγορεύεται ρητά η σύνδεση ή η σύνδεση με τον Ιστότοπο από ιστότοπους,
			πλατφόρμες, φόρουμ, συνομιλίες, ιστολόγια ή κοινωνικά δίκτυα αντίθετα με το νόμο, τα ήθη
			και καλά έθιμα, ειδικά εκείνα με πορνογραφικό, παράνομο, παράνομο ή
			περιεχόμενο που παραβιάζει τα ανθρώπινα δικαιώματα.
		</p>
		<p>
			Από την άλλη πλευρά, ο ιστότοπος μπορεί να περιέχει συνδέσμους προς ιστότοπους τρίτων,
			πλατφόρμες, φόρουμ, συνομιλίες, ιστολόγια ή κοινωνικά δίκτυα. Το {siteName} δεν το κάνει
			διαθέτουν τα ανθρώπινα ή/και τεχνικά μέσα για να γνωρίζουν ή να ελέγχουν τις πληροφορίες και
			περιεχόμενο που εμφανίζεται σε ιστότοπους τρίτων. Επομένως, σε καμία περίπτωση δεν θα το {siteName}
			 είναι υπεύθυνος για το περιεχόμενο των συνδεδεμένων ιστότοπων και σύμφωνα με την αρ
			Οι περιστάσεις μπορεί να θεωρηθούν ότι οι σύνδεσμοι είναι αποτελεσματική γνώση του περιεχομένου
			από τους ιστότοπους στους οποίους συνδέονται.
		</p>
		<h3>16. ΠΡΟΣΤΑΣΙΑ ΔΕΔΟΜΕΝΩΝ</h3>
		<p>
			Όπως ορίζεται στο {privacyPolicyLink} του, το {siteName} αναλαμβάνει να χρησιμοποιήσει το χρήστη
			δεδομένα, να σέβονται την εμπιστευτικότητά τους και να τα χρησιμοποιούν σύμφωνα με την
			σκοπό της θεραπείας, καθώς και να συμμορφωθεί με την υποχρέωσή του να τη σώσει.
			και να προσαρμόσουν όλα τα μέτρα για την αποφυγή αλλοίωσης, απώλειας, επεξεργασίας ή μη εξουσιοδοτημένης
			πρόσβαση σύμφωνα με τις διατάξεις της κείμενης νομοθεσίας σχετικά με την
			προστασία των προσωπικών δεδομένων.
		</p>
		<p>
			Ο ιστότοπος ενσωματώνει κατάλληλες διασφαλίσεις και χρησιμοποιεί βιομηχανικά πρότυπα
			τεχνολογία για τη βελτίωση της ασφάλειας, της ακεραιότητας, της πληρότητας, της ακρίβειας και
			προστασία των προσωπικών δεδομένων που έχει συλλέξει και καθιερώσει
			εύλογες προφυλάξεις για την προστασία αυτών των πληροφοριών από πιθανή απώλεια ή
			κακή χρήση. Οι κανόνες του για την προστασία και την ασφάλεια των δεδομένων επανεξετάζονται περιοδικά
			και βελτιώθηκε όταν είναι απαραίτητο, και προσπαθεί να διασφαλίσει ότι μόνο εξουσιοδοτείται
			άτομα μπορούν να έχουν πρόσβαση στις πληροφορίες που παρέχονται από τον Χρήστη.
		</p>
		<p>
			Για να μάθετε περισσότερα σχετικά με τη διαχείριση και τη θεραπεία που πραγματοποιεί ο χρήστης {siteName}
			 από τα δεδομένα σας, διαβάστε το {privacyPolicyLink} και το {cookiesPolicyLink}.
		</p>
		<h3>17. ΔΙΑΡΚΕΙΑ ΚΑΙ ΤΡΟΠΟΠΟΙΗΣΗ</h3>
		<p>
			Αυτοί οι όροι χρήσης θα ισχύουν για όσο διάστημα είναι εκτεθειμένοι
			χρήστες, έτσι ώστε μόλις τροποποιηθούν ή ενημερωθούν πλήρως ή εν μέρει,
			οι όροι αυτοί θα πάψουν να ισχύουν, αποτελώντας τους νέους όρους χρήσης
			εκείνων που συνεχίζουν να ρυθμίζουν τη χρήση της Ιστοσελίδας.
		</p>
		<p>
			Το {siteName} διατηρεί το δικαίωμα να ελέγξει, να τροποποιήσει ή να ενημερώσει αυτά
			συνθήκες χρήσης ανά πάσα στιγμή. Σε περίπτωση οποιασδήποτε αλλαγής αυτών των συνθηκών
			χρήσης για οποιονδήποτε λόγο, το {siteName} θα ειδοποιήσει τους χρήστες στην αρχική σελίδα του
			στο διαδίκτυο σχετικά με την εν λόγω περίσταση, ώστε να είναι δεόντως ενημερωμένοι και να μπορούν να συμβουλεύονται
			τις αναθεωρήσεις, τροποποιήσεις ή ενημερώσεις των παρόντων συνθηκών χρήσης
			την ικανοποίησή σας.
		</p>
		<h3>18. ΓΕΝΙΚΑ</h3>
		<p>
			Σε καμία περίπτωση και σε καμία περίπτωση δεν επιτρέπεται η μη άσκηση των δικαιωμάτων σας
			από το {siteName} θεωρείται ως παραίτηση από αυτά.
		</p>
		<p>
			Οι επικεφαλίδες που περιέχονται σε αυτούς τους όρους είναι απλώς ενδεικτικές ή
			ενημερωτικά, ώστε να μην επηρεάζουν, να πληρούν ή να επεκτείνουν την ερμηνεία
			τούτου.
		</p>
		<p>
			Σε περίπτωση που κάποια από τις ρήτρες που περιέχονται σε αυτούς τους όρους ήταν
			κηρύχθηκε άκυρη, καταχρηστική ή μη εκτελεστή, εν όλω ή εν μέρει, από δικαστή
			ή διοικητικό όργανο, η εν λόγω δήλωση θα επηρεάσει μεμονωμένα τη ρήτρα
			εν λόγω, θεωρώντας το ως μη και χωρίς την κήρυξη ακυρότητας, κατάχρησης ή
			η μη εφαρμογή επεκτείνεται υπό οποιεσδήποτε συνθήκες και στα υπόλοιπα
			προϋποθέσεις, οι οποίες θα υφίστανται.
		</p>
		<p>
			Αυτοί οι όροι χρήσης, καθώς και το {privacyPolicyLink} και το {cookiesPolicyLink}
			διέπονται από τους ισχύοντες ισπανικούς κανονισμούς ανά πάσα στιγμή.
		</p>
		<h3>19. ΕΞΥΠΗΡΕΤΗΣΗ ΠΕΛΑΤΩΝ</h3>
		<p>
			Για οποιαδήποτε διευκρίνιση, περιστατικό ή ισχυρισμό, μπορείτε να επικοινωνήσετε μαζί μας μέσω:<br />
			E-mail: {supportLink}<br />
			Ταχυδρομική διεύθυνση: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Βαρκελώνη, Ισπανία.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Τελευταία ενημέρωση: 10 Ιουνίου 2024',
		content: `
			<h3>1. Υπεύθυνος και περιγραφή</h3>
			<h5>1.1. Υπεύθυνος</h5>
			<p>Το άτομο που είναι υπεύθυνο για τη θεραπεία αυτού του ιστότοπου είναι η Remove Background S.L (εφεξής Remove Background 
			ή της Υπηρεσίας), με διεύθυνση Λεωφ. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Βαρκελώνη, Ισπανία.</p>
			<p>NIF: B56768260<br> Διεύθυνση ηλεκτρονικού ταχυδρομείου: {supportLink}</p>

			<h5>1.2. Περιγραφή</h5>
			<p>Η αποδοχή της πολιτικής απορρήτου του Remove Background (εφεξής "Πολιτική απορρήτου"), είναι απαραίτητη προϋπόθεση 
				για τη χρήση της ιστοσελίδας μας και την παροχή της υπηρεσίας (εφεξής η «Υπηρεσία»).<br>
				Αυτή η Πολιτική Απορρήτου ρυθμίζει τη συλλογή, επεξεργασία και χρήση των προσωπικών και μη προσωπικών σας πληροφοριών 
				ως χρήστης του Remove Background, από την ημερομηνία έναρξης ισχύος που εμφανίζεται στην κεφαλίδα.<br>
				Για την επεξεργασία των προσωπικών σας δεδομένων, το Remove Background συμμορφώνεται με την ισχύουσα τοπική και ευρωπαϊκή νομοθεσία, 
				καθώς και τους κανονισμούς εφαρμογής του.</p>


			<h3>2. Συλλέχθηκαν πληροφορίες</h3>
			<p>Η πρόσβαση στον ιστότοπό μας μπορεί να γίνει χωρίς την ανάγκη παροχής οποιασδήποτε πληροφορίας, αν και για εγγραφή και/ 
				ή να συνάψετε τα σχέδιά μας, θα χρειαστεί να μας παρέχετε ορισμένες προσωπικές πληροφορίες. Οι πληροφορίες (προσωπικές 
				ή μη) που συλλέγονται από την Υπηρεσία ενδέχεται να διαφέρουν ανάλογα με αυτό.<br>
				Οι προσωπικές και μη προσωπικές πληροφορίες που συλλέγονται από την Υπηρεσία θα έρθουν σε εμάς με τρεις τρόπους: 1) αυτόν που 
				συλλέγεται αυτόματα 2) αυτό που μας παρέχετε οικειοθελώς και 3) αυτό που παρέχεται από τρίτους.</p>

			<h5>2.1. Αυτό που συλλέγεται αυτόματα</h5>
			<p>Αυτές οι πληροφορίες θα αποτελούνται από:</p>
			<ul>
				<li>Αυτό που συλλέγεται μέσω cookie ή παρόμοιων μηχανισμών που είναι αποθηκευμένοι στη συσκευή σας, πάντα με τη συγκατάθεσή σας ή εντός 
					σύμφωνα με άλλες νομικές βάσεις. Ελέγξτε την Πολιτική μας για τα Cookies για περισσότερες πληροφορίες.</li>
				<li>Η IP από την οποία γίνεται η σύνδεση, ο τύπος της συσκευής που χρησιμοποιείται και τα χαρακτηριστικά της, η έκδοση της 
					το λειτουργικό σύστημα, τον τύπο του προγράμματος περιήγησης, τη γλώσσα, την ημερομηνία, τη χώρα, την ώρα του αιτήματος, 
					το URL από το από το οποίο προέρχεστε, το URL στο οποίο πηγαίνετε ή το δίκτυο κινητής τηλεφωνίας που χρησιμοποιείται, μεταξύ άλλων.</li>
				<li>Δεδομένα χρήσης υπηρεσίας και πιθανά σφάλματα που εντοπίστηκαν κατά τη χρήση τους.</li>
				<li>Επιπλέον, το Remove Background χρησιμοποιεί το Google Analytics, μια αναλυτική υπηρεσία που παρέχεται από την Google, LLC. 
					με έδρα τις Ηνωμένες Πολιτείες με έδρα στη διεύθυνση 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Για την παροχή αυτών των υπηρεσιών, χρησιμοποιούν cookies που συλλέγουν πληροφορίες, συμπεριλαμβανομένης της διεύθυνσης IP του χρήστη, 
					τα οποία θα μεταδοθούν, θα υποβληθούν σε επεξεργασία και θα αποθηκευτούν από την Google σύμφωνα με τους όρους που καθορίζονται στον ιστό www.google.com. 
					Συμπεριλαμβανομένης της πιθανής διαβίβασης των εν λόγω πληροφοριών σε τρίτους για λόγους νομικής απαίτησης ή 
					όταν τα εν λόγω τρίτα μέρη επεξεργάζονται τις πληροφορίες για λογαριασμό της Google.</li>
			</ul>
			<p>Σε κάθε περίπτωση, μπορείτε να απενεργοποιήσετε τα cookie του Google Analytics από <a href="{externalLink: disableGoogleAnalyticsLink}">εδώ</a>.</p>

			<h5>2.2. Αυτό που παρέχετε οικειοθελώς</h5>
			<p>Αυτές οι πληροφορίες θα αποτελούνται από:</p>
			<ul>
				<li>Όλα τα δεδομένα είναι υποχρεωτικά.</li>
				<li>Αυτό που απαιτείται από την Κατάργηση φόντου για την ολοκλήρωση της εγγραφής σας στον ιστό: όνομα και επώνυμο, διεύθυνση και email, μεταξύ άλλων.</li>
				<li>Όλα τα δεδομένα είναι υποχρεωτικά.</li>
				<li>Οι πληροφορίες, προσωπικές ή μη, για την ολοκλήρωση της σύμβασης για την υπηρεσία, όπως η διεύθυνση email και ο αριθμός της πιστωτικής ή χρεωστικής κάρτας σας.</li>
				<li>Οι πληροφορίες, προσωπικές ή μη, που ενδέχεται να περιέχουν τα μηνύματα που αποστέλλονται μέσω των καναλιών επικοινωνίας ή γνώμης που έχουν δημιουργηθεί στην Υπηρεσία, 
					για παράδειγμα το όνομα και το email σας.</li>
			</ul>

			<h5>2.3. Αυτό που παρέχεται από τρίτους</h5>
			<p>Αυτές οι πληροφορίες θα αποτελούνται από:</p>
			<ul>
				<li>Αυτή που παρέχεται από συστήματα πληρωμών ή επεξεργαστές πιστωτικών καρτών, όπως η ώρα αγοράς ή το ποσό της.</li>
			</ul>


			<h3>3. Δικαιώματα και σκοποί</h3>
			<p>Σας ενημερώνουμε ότι η συμπλήρωση των εντύπων είναι εθελοντική. Ωστόσο, εάν δεν συμπληρώσετε τα απαιτούμενα πεδία 
				(συνήθως σημειώνεται με αστερίσκο), η χρήση ορισμένων λειτουργιών της Υπηρεσίας δεν θα είναι δυνατή ή θα είναι περιορισμένη.<br>
				Τα προσωπικά δεδομένα που μας παρέχετε θα ενσωματωθούν και θα υποβληθούν σε επεξεργασία στο Μητρώο Δραστηριοτήτων Θεραπείας του Remove Background 
				για να μπορέσουμε να ανταποκριθούμε στα αιτήματά σας, να παρέχουμε την υπηρεσία που ζητήσατε και να σας κρατάμε ενήμερους για θέματα που σχετίζονται με τη δραστηριότητα 
				της εταιρείας και των υπηρεσιών της.<br>
				Μπορείτε να ασκήσετε ανά πάσα στιγμή τα δικαιώματα πρόσβασης, διόρθωσης, διαγραφής, περιορισμού της θεραπείας σας, 
				αντίθεση και φορητότητα των προσωπικών σας δεδομένων μέσω ηλεκτρονικού ταχυδρομείου στη διεύθυνση: {supportLink} ή στην ταχυδρομική διεύθυνση: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Βαρκελώνη, Ισπανία.<br>
				Και στις δύο περιπτώσεις, πρέπει να ταυτοποιηθείτε με το όνομα και το επώνυμό σας, καθώς και αντίγραφο του DNI ή της εθνικής σας ταυτότητας, εάν είναι απαραίτητο.<br>
				Σε περίπτωση που έχετε δώσει τη συγκατάθεσή σας για συγκεκριμένο σκοπό, έχετε το δικαίωμα να ανακαλέσετε τη συγκατάθεσή σας ανά πάσα στιγμή, 
				χωρίς να θίγεται η νομιμότητα της θεραπείας με βάση τη συγκατάθεση πριν από την απόσυρσή της.<br>
				Επιπλέον, εάν θεωρείτε ότι υπάρχει πρόβλημα με τον τρόπο με τον οποίο το Remove Background χειρίζεται τα δεδομένα σας, 
				μπορείτε να απευθύνετε τα παράπονά σας στην <a href="{knowYourRightsLink}">αρχή προστασίας δεδομένων</a> που αντιστοιχεί, που είναι η <a href="{aepdLink}">Ισπανική Υπηρεσία Προστασίας Δεδομένων</a> 
				αυτό που αναφέρεται στην περίπτωση της Ισπανίας.</p>


			<h3>4. Ηλικία</h3>
			<p>Σχετικά με τη χρήση της διαδικτυακής υπηρεσίας, δηλώνετε ότι είστε ενήλικος και ότι έχετε τα απαραίτητα νομικά 
				την ικανότητα να δεσμεύεστε από την παρούσα συμφωνία και να χρησιμοποιείτε τον ιστότοπο σύμφωνα με τους όρους και τις προϋποθέσεις του, τους οποίους έχετε πλήρως 
				κατανοούν και αναγνωρίζουν.<br>
				Δηλώνετε ότι όλες οι πληροφορίες που παρέχετε για πρόσβαση στην Υπηρεσία, πριν και κατά τη χρήση της, είναι αληθείς, πλήρεις 
				και ακριβής.</p>


			<h3>5. Χρήση δεδομένων</h3>
			Η <p>Κατάργηση φόντου θα χρησιμοποιήσει τα δεδομένα που συλλέγονται για:</p>
			<ul>
				<li>Διαχείριση και ενημέρωση της Υπηρεσίας (η νομική βάση είναι το έννομο συμφέρον μας για τη διατήρηση και τη διατήρηση της Υπηρεσίας 
					ενημερωμένο και σε καλή κατάσταση).</li>
				<li>Αντιμετωπίστε τα ερωτήματα που θέτετε (η νομική βάση είναι το έννομο συμφέρον μας να ανταποκριθούμε στα αιτήματα και 
					αμφιβολίες των χρηστών μας).</li>
				<li>Επεξεργαστείτε τις πληρωμές που κάνετε (η σύμβαση είναι η νομική βάση).</li>
				<li>Παρέχετε την συμβατική υπηρεσία (η σύμβαση αποτελεί τη νομική βάση).</li>
				<li>Διατηρήστε την ασφάλεια της Υπηρεσίας, διερευνήστε παράνομες δραστηριότητες, επιβάλλετε τους όρους και τις προϋποθέσεις μας και
					βοηθούν τις κρατικές δυνάμεις ασφαλείας στο πλαίσιο των πιθανών ερευνών τους (η νομική βάση είναι η δική μας 
					έννομο συμφέρον για την εγγύηση και τη διατήρηση της ασφάλειας της Υπηρεσίας και των χρηστών της).</li>
			</ul>
			<p>Η Κατάργηση φόντου δεν χρησιμοποιεί αυτοματοποιημένες αποφάσεις, αν και μπορεί να δημιουργήσει βασικά προφίλ χρηστών, 
				η νομική βάση είναι το έννομο συμφέρον μας για εμπορικούς σκοπούς και η παροχή εξατομικευμένων προσφορών.<br>
				Επίσης, το Remove Background μπορεί να χρησιμοποιήσει πληροφορίες χρήστη με τη μορφή συγκεντρωτικών και ανώνυμων δεδομένων για να τα εμφανίσει σε τρίτα μέρη. 
				Μπορείτε επίσης να μοιραστείτε στατιστικά και δημογραφικά στοιχεία σχετικά με τους χρήστες και τη χρήση της Υπηρεσίας από αυτούς με τρίτους. 
				Ωστόσο, τίποτα από αυτά δεν θα επιτρέψει σε αυτά τα τρίτα μέρη να σας αναγνωρίσουν προσωπικά.</p>

			<h5>5.1. Σε email και φόρμες επικοινωνίας</h5>
			<p>Ο ιστότοπος διαθέτει κρυπτογράφηση SSL που επιτρέπει στον χρήστη να στέλνει τα προσωπικά του δεδομένα με ασφάλεια μέσω τυπικών φορμών επικοινωνίας.<br>
				Τα προσωπικά δεδομένα που συλλέγονται θα υπόκεινται σε αυτοματοποιημένη επεξεργασία και θα ενσωματωθούν στα αντίστοιχα αρχεία 
				του αρχείου των δραστηριοτήτων επεξεργασίας και των οποίων ο κάτοχος είναι το Remove Background.</p>
			<p>Με αυτήν την έννοια:</p>
			<ul>
				<li>Θα λάβουμε τη διεύθυνση IP σας, η οποία θα χρησιμοποιηθεί για την επαλήθευση της προέλευσης του μηνύματος, προκειμένου να σας προσφέρουμε επαρκή 
					συστάσεις (για παράδειγμα, παρουσιάστε τις πληροφορίες στη σωστή γλώσσα) και για τον εντοπισμό πιθανών παρατυπιών 
					(για παράδειγμα, πιθανές απόπειρες κυβερνοεπίθεσης στην Υπηρεσία), καθώς και δεδομένα που σχετίζονται με τον ISP σας.</li>
				<li>Ομοίως, μπορείτε να μας παρέχετε τα δεδομένα σας μέσω τηλεφώνου, email και άλλων υποδεικνυόμενων μέσων επικοινωνίας.</li>
			</ul>
			<p>Σχετικά με τα μέσα πληρωμής που χρησιμοποιούνται:</p>
			<ul>
				<li>Οι πάροχοι υπηρεσιών πληρωμών μας για να πληρώσουν για την παροχή των υπηρεσιών μας είναι πιστωτικές ή χρεωστικές κάρτες. 
					Σε καμία περίπτωση η Υπηρεσία ή το προσωπικό της δεν θα έχουν πρόσβαση στα τραπεζικά στοιχεία (για παράδειγμα, τον αριθμό της πιστωτικής κάρτας) 
					που ο χρήστης ως πελάτης θα παρέχει σε αυτά τα τρίτα μέρη.</li>
			</ul>


			<h3>6. Διατήρηση δεδομένων</h3>
			<p>Παρακάτω, υποδεικνύονται για πόσο χρονικό διάστημα διατηρούνται τα δεδομένα που επεξεργάζεται η Υπηρεσία:</p>
			<ul>
				<li>Τα συγκεντρωτικά δεδομένα θα διατηρηθούν χωρίς περίοδο διαγραφής.</li>
				<li>
					Τα δεδομένα πελατών θα διατηρηθούν για το ελάχιστο απαραίτητο και μπορούν να διατηρηθούν έως:
					<ul>
						<li>5 έτη, σύμφωνα με το άρθρο. 1964 ΑΚ (προσωπικές αγωγές χωρίς ειδικό όρο).</li>
						<li>6 έτη, σύμφωνα με το άρθρο. 30 του Εμπορικού Κώδικα (π.χ. λογιστικά βιβλία ή τιμολόγια).</li>
					</ul>
				</li>
				<li>Τα δεδομένα χρήστη θα διατηρηθούν για μέγιστη περίοδο 12 μηνών για να μπορέσουν να ανταποκριθούν στα αιτήματά τους.</li>
			</ul>


			<h3>7. Κοινή χρήση δεδομένων με τρίτα μέρη</h3>
			<p>Υπάρχουν τρίτα μέρη που διαχειρίζονται μέρος της Υπηρεσίας.<br>
				Το Remove Background απαιτεί να συμμορφώνονται με την παρούσα Πολιτική Απορρήτου όπως ισχύει, εκτός από το ότι έχουν τη δική τους. Ωστόσο, το Remove Background δεν θα είναι υπεύθυνο για τη συμμόρφωση με την εν λόγω πολιτική.<br>
				Υπό ορισμένες συνθήκες, το Remove Background ενδέχεται να μοιραστεί, να χρησιμοποιήσει ή να διατηρήσει με τρίτα μέρη οποιαδήποτε από τις προσωπικές πληροφορίες που συλλέγονται:</p>
			<ul>
				<li>Για να παρέχετε την Υπηρεσία:</li>
			</ul>
			<p>Οι πάροχοι υπηρεσιών που εκτελούν λειτουργίες για λογαριασμό μας, όπως υπηρεσίες πληρωμών, φιλοξενία ιστού, αναλυτικά στοιχεία επιχειρήσεων, εξυπηρέτηση πελατών ή μάρκετινγκ ιστού. Αυτοί οι πάροχοι υπηρεσιών ενδέχεται να συλλέγουν και να έχουν πρόσβαση στις πληροφορίες που είναι απαραίτητες για την εκτέλεση των λειτουργιών τους, αλλά δεν τους επιτρέπεται να μοιράζονται ή να χρησιμοποιούν τις πληροφορίες για οποιονδήποτε άλλο σκοπό.</p>
			<ul>
				<li>Για συνεργασία με τις αρμόδιες αρχές:</li>
			</ul>
			<p>Εάν πιστεύουμε ότι είναι εύλογα απαραίτητο να ικανοποιηθεί οποιαδήποτε νομοθεσία, νομική διαδικασία ή έννομο συμφέρον. Σε κάθε περίπτωση, θα παρέχουμε μόνο τις αυστηρά απαιτούμενες πληροφορίες.</p>


			<h3>8. Μέτρα ασφαλείας</h3>
			<p>Το Remove Background υιοθετεί όλα τα απαραίτητα τεχνικά και οργανωτικά μέτρα
				προστασία της ασφάλειας και της ακεραιότητας των προσωπικών και μη προσωπικών πληροφοριών που συλλέγονται. 
				Τόσο κατά της μη εξουσιοδοτημένης πρόσβασης όσο και της τυχαίας αλλοίωσης, απώλειας ή καταστροφής του.<br>
				Σε κάθε περίπτωση, το Remove Background δεν μπορεί να εγγυηθεί την απόλυτη ασφάλεια των πληροφοριών που συλλέγονται, 
				επομένως πρέπει να συνεργάζεστε και να χρησιμοποιείτε την κοινή λογική για τις πληροφορίες που μοιράζεστε ανά πάσα στιγμή.<br>
				Κατανοείτε και αναγνωρίζετε ότι, ακόμη και μετά τη διαγραφή, ενδέχεται να υπάρχουν προσωπικές και μη προσωπικές πληροφορίες 
				παραμένει ορατό στην κρυφή μνήμη ή εάν άλλοι χρήστες το έχουν αντιγράψει ή αποθηκεύσει.</p>


			<h3>9. Αλλαγές στην Πολιτική Απορρήτου</h3>
			<p>Μπορεί να ενημερώσουμε αυτήν την Πολιτική Απορρήτου στο μέλλον. Θα σας ενημερώσουμε για τις αλλαγές του στέλνοντας μια ειδοποίηση στη διεύθυνση ηλεκτρονικού ταχυδρομείου που παρέχεται ή/και τοποθετώντας μια ειδοποίηση σε εμφανές σημείο στον ιστότοπό μας.</p>


			<h3>10. Επικοινωνία</h3>
			<p>Εάν έχετε ερωτήσεις σχετικά με αυτήν την Πολιτική Απορρήτου, επικοινωνήστε μαζί μας στη διεύθυνση:</p>
			<p>Ηλεκτρονικό ταχυδρομείο: {supportLink}<br> 
				Διεύθυνση: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Βαρκελώνη, Ισπανία.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Τελευταία ενημέρωση: 10 Ιουνίου 2024',
		content: `
			<h3>1. Ποιος είναι υπεύθυνος και πώς να επικοινωνήσετε μαζί τους;</h3>
			<p>Ο ελεγκτής αυτού του ιστότοπου είναι το Remove Background S.L με διεύθυνση στο Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Βαρκελώνη, Ισπανία.</p>
			<p>Μπορείτε να επικοινωνήσετε μαζί του μέσω email στη διεύθυνση {supportLink}.</p>

			<h3>2. Ποια δεδομένα συλλέγονται;</h3>
			<p>
				Συλλέγουμε αυτόματα δεδομένα μέσω των cookies που φορτώνουμε στη συσκευή σας, συμπεριλαμβανομένων των αναλυτικών στοιχείων. 
				Συλλέγουμε επίσης την IP από την οποία γίνεται η σύνδεση, τον τύπο της συσκευής που χρησιμοποιείται και τα χαρακτηριστικά της, 
				την έκδοση του λειτουργικού συστήματος, τον τύπο του προγράμματος περιήγησης, τη γλώσσα, την ημερομηνία, τη χώρα, την ώρα του αιτήματος, 
				το URL από το οποίο προέρχεστε, το URL στο οποίο πηγαίνετε ή το δίκτυο κινητής τηλεφωνίας που χρησιμοποιείται, μεταξύ άλλων.<br>
				Ο χρήστης οικειοθελώς μας παρέχει κάποιες πληροφορίες όπως το όνομα και το επώνυμό του, το email ή τα τραπεζικά του στοιχεία 
				για να μπορέσετε να επικοινωνήσετε μαζί μας, να εγγραφείτε στην υπηρεσία ή να αγοράσετε μια συνδρομή.
			</p>

			<h3>3. Σε τι χρησιμεύουν τα δεδομένα που συλλέγονται;</h3>
			<p>
				Η Υπηρεσία θα χρησιμοποιήσει τα δεδομένα που συλλέγονται, μεταξύ άλλων, για τη διαχείριση και την ενημέρωση της υπηρεσίας, την απάντηση στα αιτήματά σας, 
				σας στέλνουμε το ενημερωτικό μας δελτίο και τις προωθητικές προσφορές μας μέσω email, διαχειριστείτε την εγγραφή σας στην πλατφόρμα, διαχειριστείτε και παρέχετε 
				τις υπηρεσίες που σχετίζονται με τη συνδρομή σας, επεξεργάζονται τις πληρωμές που πραγματοποιείτε και εκδίδουν τα αντίστοιχα τιμολόγια, 
				να διατηρήσει την ασφάλεια της Υπηρεσίας, να διερευνήσει παράνομες δραστηριότητες, να επιβάλει τους όρους και τις προϋποθέσεις μας και 
				βοηθούν τις δυνάμεις και τους φορείς της κρατικής ασφάλειας στο πλαίσιο των ενδεχόμενων ερευνών τους.
			</p>

			<h3>4. Πόσο καιρό διατηρούνται;</h3>
			<ul>
				<li>Τα συγκεντρωτικά δεδομένα θα διατηρηθούν χωρίς περίοδο διαγραφής.</li>
				<li>
					Τα δεδομένα πελατών θα διατηρηθούν για το ελάχιστο απαραίτητο και μπορούν να διατηρηθούν έως:
					<ul>
						<li>5 έτη, σύμφωνα με το άρθρο. 1964 ΑΚ (προσωπικές αγωγές χωρίς ειδικό όρο).</li>
						<li>6 έτη, σύμφωνα με το άρθρο. 30 του Εμπορικού Κώδικα (λογιστικά βιβλία ή τιμολόγιο, για παράδειγμα).</li>
					</ul>
				</li>
				<li>Τα δεδομένα χρήστη θα διατηρηθούν για μέγιστη περίοδο 12 μηνών προκειμένου να ανταποκριθούν στα αιτήματά τους.</li>
				<li>Τα δεδομένα χρήστη που ανεβαίνουν από την Υπηρεσία σε σελίδες και προφίλ στα κοινωνικά δίκτυα θα διατηρηθούν από τη στιγμή που ο χρήστης θα δώσει τη συγκατάθεσή του μέχρι να την αποσύρει.</li>
			</ul>

			<h3>5. Ποια είναι τα δικαιώματά σας ως χρήστης;</h3>

			<p>
				Δικαίωμα πρόσβασης: Το θιγόμενο μέρος έχει το δικαίωμα να λάβει επιβεβαίωση από τον υπεύθυνο επεξεργασίας για το αν 
				ή δεν υποβάλλονται σε επεξεργασία προσωπικά δεδομένα που τον αφορούν.
			</p>
			<p>
				Δικαίωμα διόρθωσης: το θιγόμενο μέρος έχει το δικαίωμα να ζητήσει, χωρίς αδικαιολόγητη καθυστέρηση, από τον υπεύθυνο επεξεργασίας δεδομένων 
				τη διόρθωση προσωπικών δεδομένων που είναι ανακριβή και που τον επηρεάζουν άμεσα. Το ίδιο θα κάνει και ο ενδιαφερόμενος 
				έχουν το δικαίωμα να συμπληρώνουν ελλιπή προσωπικά δεδομένα, μεταξύ άλλων μέσω πρόσθετης δήλωσης.
			</p>
			<p>
				Δικαίωμα διαγραφής: Είναι το δικαίωμα του θιγόμενου μέρους να λάβει, χωρίς αδικαιολόγητη καθυστέρηση, τη διαγραφή από τον υπεύθυνο επεξεργασίας 
				των προσωπικών δεδομένων που τον αφορούν.
			</p>
			<p>
				Δικαίωμα περιορισμού της επεξεργασίας δεδομένων: συνίσταται στην εξασφάλιση του περιορισμού της επεξεργασίας των δεδομένων σας από τον υπεύθυνο, 
				αν και η άσκησή του έχει δύο πτυχές: 1) Όταν αμφισβητείτε την ακρίβεια των προσωπικών σας δεδομένων, κατά τη διάρκεια μιας περιόδου που επιτρέπει 
				ο υπεύθυνος να το επαληθεύσει και 2) Όταν έχετε αντιταχθεί στην επεξεργασία των προσωπικών σας δεδομένων ότι ο υπεύθυνος 
				εκτελεί βάσει έννομου συμφέροντος ή αποστολή δημοσίου συμφέροντος, ενώ ο υπεύθυνος επαληθεύει εάν αυτοί οι λόγοι 
				επικρατήσει του δικού σας.
			</p>
			<p>
				Δικαίωμα φορητότητας δεδομένων: Είναι το δικαίωμα του θιγόμενου μέρους να λαμβάνει τα προσωπικά δεδομένα που τον αφορούν, 
				που έχει παράσχει σε υπεύθυνο επεξεργασίας δεδομένων, σε δομημένη μορφή, κοινής χρήσης και μηχανικής ανάγνωσης, και 
				να τα διαβιβάσει σε άλλον ελεγκτή χωρίς να εμποδίζεται από τον υπεύθυνο επεξεργασίας στον οποίο παρασχέθηκαν.
			</p>
			<p>
				Υπό αυτή την έννοια, το ενδιαφερόμενο μέρος θα έχει το δικαίωμα να διαβιβάζονται προσωπικά δεδομένα απευθείας από τον υπεύθυνο επεξεργασίας 
				στον ελεγκτή όταν είναι τεχνικά δυνατό.
			</p>

			<h3>6. Πώς μπορείτε να ασκήσετε τα δικαιώματά σας;</h3>

			<p>
				Μπορείτε να ασκήσετε τα δικαιώματα των προσωπικών σας δεδομένων ανά πάσα στιγμή στέλνοντας ένα email στη διεύθυνση: {supportLink} Ή στην ταχυδρομική διεύθυνση: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Βαρκελώνη, Ισπανία. Και στις δύο περιπτώσεις, πρέπει να ταυτιστείτε με το όνομα και το επώνυμό σας, 
				καθώς και αντίγραφο του DNI ή της εθνικής σας ταυτότητας, εάν χρειάζεται.<br>
				Επιπλέον, εάν θεωρείτε ότι υπάρχει πρόβλημα με τον τρόπο με τον οποίο το Remove Background χειρίζεται τα δεδομένα σας, μπορείτε να κατευθύνετε τις αξιώσεις σας 
				στην <a href="{knowYourRightsLink}">αρχή προστασίας δεδομένων</a> που αντιστοιχεί, που είναι η <a href="{aepdLink}">Ισπανική Υπηρεσία Προστασίας Δεδομένων</a> 
				αυτή που αναφέρεται στην περίπτωση της Ισπανίας.
			</p>

			<h3>7. Έχουν ληφθεί μέτρα ασφαλείας;</h3>
			<p>
				Η Υπηρεσία λαμβάνει όλα τα απαραίτητα τεχνικά και οργανωτικά μέτρα για την προστασία της ασφάλειας και της ακεραιότητας του προσωπικού 
				και μη προσωπικές πληροφορίες που συλλέγονται. Τόσο έναντι μη εξουσιοδοτημένης πρόσβασης όσο και τυχαίας αλλοίωσης, απώλειας ή καταστροφής.<br>
				Σε κάθε περίπτωση, η Υπηρεσία δεν μπορεί να εγγυηθεί την απόλυτη ασφάλεια των πληροφοριών που συλλέγονται, επομένως πρέπει να συνεργαστείτε και 
				χρησιμοποιήστε την κοινή λογική ανά πάσα στιγμή σχετικά με τις κοινές πληροφορίες.<br>
				Κατανοείτε και αναγνωρίζετε ότι, ακόμη και μετά τη διαγραφή, οι Προσωπικές και μη Προσωπικές Πληροφορίες ενδέχεται να παραμείνουν ορατές στην κρυφή μνήμη ή 
				εάν αντιγραφεί ή αποθηκευτεί από άλλους χρήστες.
			</p>

			<h3>8. Υπάρχουν μεταφορές προσωπικών δεδομένων ή διεθνείς μεταφορές;</h3>

			<p>
				Δεν μεταφέρουμε δεδομένα ή διεθνείς μεταφορές. Ωστόσο, υπάρχουν τρίτα μέρη που διαχειρίζονται μέρος της Υπηρεσίας 
				ότι απαιτούμε να συμμορφωνόμαστε με την Πολιτική Απορρήτου μας στο βαθμό που ισχύει για αυτούς και ότι έχουν τη δική τους. 
				Αυτά τα τρίτα μέρη είναι πάροχοι υπηρεσιών που εκτελούν λειτουργίες για λογαριασμό μας, όπως φιλοξενία Ιστού, 
				παρακολούθηση αναλυτικών στοιχείων ή ανάπτυξη ιστού.<br>
				Επίσης, εάν πιστεύουμε ότι είναι εύλογα απαραίτητο να ικανοποιηθεί οποιοσδήποτε νόμος, νομική διαδικασία ή έννομο συμφέρον. 
				Σε κάθε περίπτωση, θα παρέχουμε μόνο τις αυστηρά απαιτούμενες πληροφορίες.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Τελευταία ενημέρωση: 21 Ιουνίου 2024',
		content: `
			<h3>Σύνοψη</h3>
			<ul>
			    <li>Cookie που χρησιμοποιούνται: <strong>Ιδιοκτήτες και τρίτοι</strong></li>
			    <li>Χρησιμοποιούνται για τη λήψη στατιστικών στοιχείων; <strong>Ναι, με βάση το έννομο συμφέρον μας για καλύτερη διαχείριση της υπηρεσίας.</strong></li>
			    <li>Υπηρεσίες τρίτων που εγκαθιστούν cookie μέσω αυτού του ιστότοπου: <strong>Google, Google Analytics, Cloudflare και Stripe.</strong></li>
			</ul>

			<h3>Πώς να ρυθμίσετε και να απενεργοποιήσετε τα cookie</h3>
			<p>
			    Μπορείτε να επιτρέψετε, να αποκλείσετε ή να διαγράψετε τα cookies που είναι εγκατεστημένα στη συσκευή σας από το πρόγραμμα περιήγησής σας. Εάν δεν επιτρέπετε την εγκατάσταση cookies στη συσκευή σας, 
			    η εμπειρία περιήγησης μπορεί να επιδεινωθεί. Παρακάτω, μπορείτε να βρείτε πώς να ρυθμίσετε τα cookies σε κάθε πρόγραμμα περιήγησης:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Όπερα</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Τύποι και χρήσεις</h3>
			<p>Η υπηρεσία χρησιμοποιεί δικά της και cookie τρίτων για τη βελτίωση της περιήγησης, την παροχή της υπηρεσίας και τη λήψη στατιστικών στοιχείων σχετικά με τη χρήση του ιστότοπου.</p>

			<h3>2. Τι είναι ένα cookie και σε τι χρησιμοποιείται;</h3>
			<p>
			    Ένα cookie είναι ένα αρχείο κειμένου που αποστέλλεται στον υπολογιστή, το κινητό ή το tablet σας πρόγραμμα περιήγησης ιστού και χρησιμοποιείται για την αποθήκευση και ανάκτηση πληροφοριών σχετικά με
			    η περιήγηση έγινε. Για παράδειγμα, για να θυμάστε το όνομα χρήστη και τον κωδικό πρόσβασής σας ή τις προτιμήσεις του προφίλ σας.
			</p>

			<h3>3. Τι τύποι cookies υπάρχουν;</h3>
			<p>Ανάλογα με το ποιος τα διαχειρίζεται:</p>
			<ul>
			    <li>Δικά του cookie. αποστέλλονται στο πρόγραμμα περιήγησής σας από τον δικό μας εξοπλισμό ή τομείς ιστού.</li>
			    <li>Cookie τρίτων. αποστέλλονται στο πρόγραμμα περιήγησής σας από εξοπλισμό ή τομείς ιστού που δεν διαχειριζόμαστε άμεσα, αλλά από μια τρίτη οντότητα όπως η Google.</li>
			</ul>
			<p>Με βάση το χρονικό διάστημα που παραμένουν ενεργά, υπάρχουν:</p>
			<ul>
			    <li>Cookies περιόδου σύνδεσης. παραμένουν στο αρχείο cookie του προγράμματος περιήγησής σας μέχρι να αποχωρήσετε από τον ιστότοπο, επομένως κανένα δεν παραμένει στη συσκευή σας.</li>
			    <li>Μόνιμα cookie. παραμένουν στη συσκευή σας και ο ιστότοπός μας τα διαβάζει κάθε φορά που κάνετε μια νέα επίσκεψη. Αυτά τα cookie σταματούν να λειτουργούν μετά από μια συγκεκριμένη ημερομηνία.</li>
			</ul>
			<p>Τέλος, σύμφωνα με τον σκοπό τους, έχουμε:</p>
			<ul>
			    <li>Τεχνικά cookies. βελτιώνουν την περιήγηση και τη σωστή λειτουργία του ιστότοπου.</li>
			    <li>Cookies εξατομίκευσης. επιτρέπουν την πρόσβαση στην υπηρεσία με προκαθορισμένα χαρακτηριστικά βάσει μιας σειράς κριτηρίων.</li>
			    <li>Cookies αναλυτικών στοιχείων. επιτρέπουν τη μέτρηση και τη στατιστική ανάλυση της χρήσης της παρεχόμενης υπηρεσίας.</li>
			</ul>
			<p>Λίστα cookie τρίτων που χρησιμοποιούνται από το <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Τα cookie τους (NID ή CONSENT) επιτρέπουν την εξατομίκευση του τρόπου εμφάνισης των διαφημίσεων εκτός Google ή την αποθήκευση πληροφοριών
			        όπως η προτιμώμενη γλώσσα κατά την εμφάνιση των αποτελεσμάτων αναζήτησης.<br><a href="{externalLink: googleCookieTypes}">Περισσότερες πληροφορίες</a> σχετικά με τους τύπους cookie που χρησιμοποιεί η Google στις διάφορες υπηρεσίες της.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Τα cookie τους (όπως _ga) επιτρέπουν την καταμέτρηση πόσες φορές ένας χρήστης επισκέπτεται έναν ιστότοπο, πώς, πότε και από πού.<br>
			        Σε κάθε περίπτωση, μπορείτε να απενεργοποιήσετε τα cookie του Google Analytics από <a href="{externalLink: disableGoogleAnalytics}">εδώ</a>.
			    </li>
			    <li>Cloudflare: Για να μάθετε σχετικά με την πολιτική και τη χρήση των cookie του Cloudflare, κάντε κλικ σε <a href="{externalLink: cloudflareCookiesPolicy}">αυτόν τον σύνδεσμο</a>.</li>
			    <li>Stripe: Βρείτε πληροφορίες <a href="{externalLink: stripeCookiesPolicy}">εδώ</a> σχετικά με την πολιτική και τη χρήση των cookie του Stripe.</li>
			</ul>
		`
	}
};
